import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import type { ShellContext } from "utilities/full-story";

const SHELL_LAYOUT_COMPONENT = "global-navigation-shell";

interface NewRelicAgent {
  setCustomAttribute?: (name: string, value: string) => void;
  noticeError?: (error: Error, customAttributes?: Record<string, string>) => void;
}

const getNewRelicAgent = (): NewRelicAgent | undefined =>
  (window as Window & { newrelic?: NewRelicAgent }).newrelic;

export const setShellLayoutAttributes = (shellContext?: ShellContext) => {
  const agent = getNewRelicAgent();
  if (!agent?.setCustomAttribute) return;

  agent.setCustomAttribute("layoutComponent", SHELL_LAYOUT_COMPONENT);
  if (shellContext) {
    agent.setCustomAttribute("shellContext", shellContext);
  }
};

export const reportPreferredLanguageSyncFailure = (status: string) => {
  getNewRelicAgent()?.noticeError?.(new Error("PreferredLanguageDealSyncFailed"), { status });
};

export const initNewRelic = () => {
    // Populate using values in copy-paste JavaScript snippet.
    const options = {
      init: {
        distributed_tracing: {
          enabled: true,
          cors_use_newrelic_header: true,
          cors_use_tracecontext_headers: true,
          allowed_origins: globalThis.env.NEW_RELIC_ALLOWED_ORIGINS.split(','),
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] },
      }, // NREUM.init
      info: { beacon: "bam.nr-data.net", errorBeacon: "bam.nr-data.net", licenseKey: globalThis.env.NEW_RELIC_LICENSE_KEY, applicationID: globalThis.env.NEW_RELIC_AGENT_ID_AND_APPLICATION_ID, sa: 1 }, // NREUM.info
      loader_config: {
        accountID:  globalThis.env.NEW_RELIC_ACCOUNT_ID_AND_TRUST_KEY,
        trustKey: globalThis.env.NEW_RELIC_ACCOUNT_ID_AND_TRUST_KEY,
        agentID: globalThis.env.NEW_RELIC_AGENT_ID_AND_APPLICATION_ID,
        licenseKey: globalThis.env.NEW_RELIC_LICENSE_KEY,
        applicationID: globalThis.env.NEW_RELIC_AGENT_ID_AND_APPLICATION_ID,
      }, // NREUM.loader_config
    };

    // The agent loader code executes immediately on instantiation.
    const _agent = new BrowserAgent(options);
};
